import { User } from '@domain/account/models/User';
import { Company } from '@domain/account/models/Company';
import { container } from '@infrastructure/container';
import { useAuthStore } from '../store/AuthStore';
import { getImpersonationTargetUserId, getOperatorCompanyId } from './impersonation';

export type ApplySession = (user: User, jwt: string, company?: Company) => Promise<void>;

export async function establishSessionForCurrentAppwriteUser(applySession: ApplySession): Promise<void> {
  const jwt = await useAuthStore.getState().refreshJwt();
  if (!jwt) {
    throw new Error('Failed to refresh session');
  }

  const userResponse = await container.authRepository.getCurrentUser();
  if (userResponse.status === 'error' || !userResponse.data) {
    throw new Error('Failed to load user');
  }

  const storedCompanyId = useAuthStore.getState().companyId;
  const operatorCompanyId = getOperatorCompanyId();
  const impersonating = Boolean(getImpersonationTargetUserId());
  const companiesResponse = await container.companyRepository.getCompanies();
  const companies = companiesResponse.status === 'success' ? companiesResponse.data ?? [] : [];
  const preferredCompanyId =
    impersonating && storedCompanyId === operatorCompanyId
      ? undefined
      : storedCompanyId;
  const nextCompany = companies.find((candidate) => candidate.id === preferredCompanyId) ?? companies[0];

  if (!nextCompany) {
    throw new Error('No company found for this account');
  }

  await applySession(userResponse.data, jwt, nextCompany);
}
